export default 'https://coin-img.wepin.io/coinlogo/default_coin_img.svg'
